module.exports = __webpack_public_path__ + "img/chart.ef8c9f67.svg";